var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "card card-light d-flex flex-column" }, [
    _c("div", { staticClass: "page-subtitle text-white" }, [
      _vm._v(_vm._s(_vm.$t("payment.summary.recap.transaction")))
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "total-lines content mt-4" }, [
      _vm._v(
        "\n    " + _vm._s(_vm.$t("payment.summary.total.annonces")) + "\n    "
      ),
      _c("span", [_vm._v(_vm._s(_vm.totalAnnonces))])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "total-lines content" }, [
      _vm._v(
        "\n    " +
          _vm._s(_vm.$t("payment.summary.licensed.annonces")) +
          "\n    "
      ),
      _c("span", [_vm._v(_vm._s(_vm.totalLicensed) + "€")])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "total-lines content" }, [
      _vm._v(
        "\n    " +
          _vm._s(_vm.$t("payment.summary.unlicensed.annonces")) +
          "\n    "
      ),
      _c("span", [_vm._v(_vm._s(_vm.totalUnlicensed) + "€")])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "total-lines content" }, [
      _vm._v(
        "\n    " +
          _vm._s(_vm.$t("payment.summary.additional.reward")) +
          "\n    "
      ),
      _c("span", [_vm._v(_vm._s(_vm.totalAdditionalReward) + "€")])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "total-lines total mt-3" }, [
      _vm._v("\n    " + _vm._s(_vm.$t("payment.summary.total")) + "\n    "),
      _c("span", [_vm._v(_vm._s(_vm.total) + "€")])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e8a4ae32", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e8a4ae32","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/annonce/PaymentSummaryTotalCard.vue
// module id = 2yg8
// module chunks = 0